export default "__VITE_ASSET__Lk$XmMtW__"